// constants.ts

/**
 * Centralized keys for localStorage and IndexedDB to prevent typos and ensure consistency.
 */
export const LOCAL_STORAGE_KEYS = {
  SETTINGS: 'spark_settings',
  TAGS: 'spark_tags',
  RSS_FEEDS: 'spark_rss_feeds',
  FEED_ITEMS: 'spark_feed_items',
  PERSONAL_ITEMS: 'spark_personal_items',
  TEMPLATES: 'spark_templates',
  WATCHLIST: 'spark_watchlist',
  SPACES: 'spark_spaces',
  CUSTOM_MENTORS: 'spark_custom_mentors',
  CUSTOM_QUOTES: 'spark_custom_quotes',
  AUTH_TOKENS: 'spark_auth_tokens', // For Google Auth
  PASSWORD_VAULT: 'spark_password_vault', // For Password Manager
  COMFORT_CHALLENGE: 'spark_comfort_challenge', // For Comfort Zone Crusher
  WORKOUT_TEMPLATES: 'spark_workout_templates', // For Workout Templates
  PERSONAL_EXERCISES: 'spark_personal_exercises', // For Personal Exercise Library
  BODY_WEIGHT: 'spark_body_weight', // For Body Weight Tracking
  WORKOUT_SESSIONS: 'spark_workout_sessions', // For Workout History
  GOOGLE_CALENDAR_STORE: 'google_calendar_events', // ✅ PERF: Added for IndexedDB indexing
};

/**
 * Defines the types of items that can be created in the feed.
 */
export const FEED_ITEM_TYPES = ['rss', 'spark', 'news', 'mentor'] as const;

/**
 * Defines the types of items that are considered personal and appear on the home screen.
 */
export const PERSONAL_ITEM_TYPES = [
  'task',
  'habit',
  'antigoal',
  'workout',
  'note',
  'link',
  'learning',
  'goal',
  'journal',
  'book',
  'idea',
  'gratitude',
  'roadmap',
] as const;

/**
 * A combined list of all possible item types in the application.
 */
export const ITEM_TYPES = [...FEED_ITEM_TYPES, ...PERSONAL_ITEM_TYPES] as const;

// --- Filter Types ---

export const FEED_FILTER_TYPES = ['all', 'unread', 'sparks', 'rss'] as const;
export const PERSONAL_ITEM_FILTER_TYPES = [
  'all',
  'task',
  'habit',
  'antigoal',
  'book',
  'note',
  'link',
  'learning',
  'goal',
  'journal',
  'workout',
  'idea',
  'roadmap',
] as const;

// --- UI Constants ---
// Use Record<string, string> to avoid circular dependency with types.ts
export const PERSONAL_ITEM_TYPE_COLORS: Record<string, string> = {
  task: 'var(--success)',
  habit: 'var(--pink)',
  antigoal: 'var(--danger)',
  workout: 'var(--pink)',
  note: 'var(--warning)',
  link: 'var(--link)',
  learning: 'var(--sky)',
  goal: 'var(--teal)',
  journal: 'var(--purple)',
  book: 'var(--purple)',
  idea: 'var(--warning)',
  gratitude: 'var(--accent-highlight)',
  roadmap: 'var(--blue)',
};

export const AVAILABLE_ICONS = [
  'sparkles',
  'lightbulb',
  'clipboard',
  'check-circle',
  'link',
  'summarize',
  'user',
  'book-open',
  'target',
  'dumbbell',
  'feed',
  'chart-bar',
  'brain',
  'roadmap',
  'rss',
] as const;

/**
 * RSS Feed Categories with Hebrew labels
 */
export const RSS_CATEGORIES = {
  economics: 'כלכלה',
  tech: 'טכנולוגיה',
  news: 'חדשות',
  behavioral: 'התנהגות',
  general: 'כללי',
} as const;
